import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { createModelConceptAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/createModelConceptAttribute';
import { updateRuleAttributeRange } from 'src/containers/ProjectDiagram/utils/rules/updateRuleAttributeRange';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const addRangeToAttributeModelData =
  ({ value, range }: { value: string; range: string }) =>
  (model: Model) => {
    const existingAttribute =
      model.modelData.attributesByIri[value] ||
      createModelConceptAttribute({ value });

    const existingRange = existingAttribute.ranges[range] || {
      value: range,
    };

    const updatedAttribute = {
      ...existingAttribute,
      ranges: {
        ...existingAttribute.ranges,
        [range]: {
          ...existingRange,
        },
      },
    };
    setDataProperty<ModelData>(model)(model.modelData, 'attributesByIri', {
      ...model.modelData.attributesByIri,
      [value]: updatedAttribute,
    });

    updateRuleAttributeRange(updatedAttribute)(model);
  };
